import React from 'react';
import SearchableSelect from '../SearchableSelect';

const SegmentReferences = ({ segments, currentId, references, onChange }) => {
  const selected = references.map((row) => String(row.segment_id));
  const options = segments.filter((segment) => String(segment.id) !== String(currentId) &&
    !selected.includes(String(segment.id))).map((segment) => ({ value: segment.id, label: segment.name }));

  return (
    <div className='space-y-2'>
      <p className='text-xs font-semibold text-slate-600'>Segments</p>
      <p className='text-xs text-slate-500'>
        Include combines players from the selected segments. Countries and attributes narrow that audience.
        Exclude removes players from it.
      </p>
      {references.map((row, index) => (
        <div key={row.segment_id} className='flex items-center gap-2'>
          <select
            aria-label={`Segment rule ${index + 1}`}
            className='border border-slate-300 rounded px-2 py-1.5 text-sm'
            value={row.operator}
            onChange={(e) => onChange(references.map((item, i) => i === index ? { ...item, operator: e.target.value } : item))}
          >
            <option value='include'>Include</option>
            <option value='exclude'>Exclude</option>
          </select>
          <span className='text-sm text-slate-800 flex-1'>
            {segments.find((segment) => String(segment.id) === String(row.segment_id))?.name || `Missing segment #${row.segment_id}`}
          </span>
          <button type='button' aria-label={`Remove segment ${index + 1}`} className='text-slate-400 hover:text-red-600 px-2'
            onClick={() => onChange(references.filter((_, i) => i !== index))}>×</button>
        </div>
      ))}
      <SearchableSelect
        options={options}
        value=''
        placeholder='Search and add a segment…'
        onChange={(id) => id && onChange([...references, { segment_id: Number(id), operator: 'include' }])}
      />
    </div>
  );
};

export default SegmentReferences;
